import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { generatePath, useNavigate } from 'react-router-dom';
import { useUserData } from '@/components/pages/SettingsPage/MainContent/shared/useUserData';
import { Icon } from '@/components/shared/display/Icon';
import { EllipsisVerticalIcon, PenIcon, TrashIcon } from '@/assets/Icons';

interface UserActionsDropdownProps {
  userId: string;
}

export const UserActionsDropdown: React.FC<UserActionsDropdownProps> = ({ userId }) => {
  const navigate = useNavigate();
  const { deleteUser } = useUserData();

  const handleEditUserClick = () => {
    navigate(generatePath(':userId/edit', { userId }));
  };

  const handleDeleteUserClick = () => {
    deleteUser(userId);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="[&_svg]:size-7 w-10">
        <Button variant="icon" aria-label="User actions">
          <Icon icon={EllipsisVerticalIcon} />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="min-w-[200px]">
        <DropdownMenuItem onClick={handleEditUserClick} className="py-3 px-4 cursor-pointer [&_svg]:size-7">
          <Icon icon={PenIcon} />
          <span className="text-md">Edit User</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={handleDeleteUserClick}
          className="py-3 px-4 cursor-pointer [&_svg]:size-7 text-[#CC0000]"
        >
          <Icon icon={TrashIcon} />
          <span className="text-md">Delete User</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
